module.exports = __webpack_public_path__ + "static/media/fondo_actuacion.3e13f466.jpg";